import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(
        private injector: Injector,
        private router: Router,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authService = this.injector.get(AuthService);
        if (authService.isAuthenticated) {
            const authRequest = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + authService.token)
            });
            return next.handle(authRequest).do((event: HttpEvent<any>) => {
                // if (event instanceof HttpResponse) {
                //   // do stuff with response if you want
                // }
              }, (err: any) => {
                if (err instanceof HttpErrorResponse) {
                  if (err.status === 401) {
                    // redirect to the login route
                    // or show a modal
                    this.router.navigate(['auth/login']);
                  }
                }
              });;
        } else {
            return next.handle(req.clone());
        }
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/auth-interceptor.service.ts